/* tslint:disable */
/* eslint-disable */
/**
 * Leads API
 * API for managing leads (potential customers from external sources)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomVariableDto } from './CustomVariableDto';
import {
    CustomVariableDtoFromJSON,
    CustomVariableDtoFromJSONTyped,
    CustomVariableDtoToJSON,
    CustomVariableDtoToJSONTyped,
} from './CustomVariableDto';

/**
 * TEMPORARY - Command to send an email from a lead (POC)
 * @export
 * @interface SendLeadEmailTemporaryCommand
 */
export interface SendLeadEmailTemporaryCommand {
    /**
     * ID of the lead
     * @type {string}
     * @memberof SendLeadEmailTemporaryCommand
     */
    leadId: string;
    /**
     * List of recipient emails
     * @type {Array<string>}
     * @memberof SendLeadEmailTemporaryCommand
     */
    emails: Array<string>;
    /**
     * Variables personnalisees par le front-end (optionnel). Ex - custom_text pour le message personnalise
     * @type {Array<CustomVariableDto>}
     * @memberof SendLeadEmailTemporaryCommand
     */
    customVariables?: Array<CustomVariableDto>;
}

/**
 * Check if a given object implements the SendLeadEmailTemporaryCommand interface.
 */
export function instanceOfSendLeadEmailTemporaryCommand(value: object): value is SendLeadEmailTemporaryCommand {
    if (!('leadId' in value) || value['leadId'] === undefined) return false;
    if (!('emails' in value) || value['emails'] === undefined) return false;
    return true;
}

export function SendLeadEmailTemporaryCommandFromJSON(json: any): SendLeadEmailTemporaryCommand {
    return SendLeadEmailTemporaryCommandFromJSONTyped(json, false);
}

export function SendLeadEmailTemporaryCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendLeadEmailTemporaryCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'leadId': json['leadId'],
        'emails': json['emails'],
        'customVariables': json['customVariables'] == null ? undefined : ((json['customVariables'] as Array<any>).map(CustomVariableDtoFromJSON)),
    };
}

export function SendLeadEmailTemporaryCommandToJSON(json: any): SendLeadEmailTemporaryCommand {
    return SendLeadEmailTemporaryCommandToJSONTyped(json, false);
}

export function SendLeadEmailTemporaryCommandToJSONTyped(value?: SendLeadEmailTemporaryCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leadId': value['leadId'],
        'emails': value['emails'],
        'customVariables': value['customVariables'] == null ? undefined : ((value['customVariables'] as Array<any>).map(CustomVariableDtoToJSON)),
    };
}

